declare namespace $ {

	export class $mol_icon_account_multiple extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=multiple.view.tree.d.ts.map